import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { Card, Collapse, useTheme } from "@mui/material";
import { RightDetailListItem } from "../../RightDetailListItem";
import { useIsMobile } from "../../../hooks/isMobile";
import { IconType } from "../../../icons";
import { PiperDivider } from "../../PiperDivider";

export const StatsCountsExpandableSection: FunctionComponent<
  IStatsCountsExpandableSectionProps
> = ({ sectionName, title, children }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div key={`${sectionName}_section`}>
      <Card
        elevation={5}
        className={isMobile ? styles.itemCardMobile : styles.itemCard}
        key={`${sectionName}_card`}
        style={{ backgroundColor: theme.palette.background.default }}
      >
        <RightDetailListItem
          title={title}
          style={{ backgroundColor: theme.palette.background.default }}
          key={`${sectionName}_title`}
          theNewIconType={isExpanded ? IconType.KeyboardArrowUp : IconType.KeyboardArrowDown}
          onClick={() => setIsExpanded(state => !state)}
          boldTitle
        />
        <Collapse in={isExpanded} timeout={"auto"}>
          <PiperDivider />
          {children}
        </Collapse>
      </Card>
    </div>
  );
};

export interface IStatsCountsExpandableSectionProps {
  sectionName: string;
  title: string;
  children: React.ReactNode;
}
